import { environment } from '../../environments/environment';


const Dashboard = {
    name: 'Dashboard',
    link: '/dashboard',
    // iconclass: 'ion-aperture',
    imgpath: 'assets/img/icons/aperture.svg',
    order: 1,
    /*label: {
        count: 2,
        classname: 'badge bg-success'
    }*/
};

const Cards = {
    name: 'Cards',
    link: '/cards',
    order: 2,
    // iconclass: 'ion-radio-waves',
    imgpath: 'assets/img/icons/radio-waves.svg'
};

const Forms = {
    name: 'Forms',
    link: '/forms',
    // iconclass: 'ion-clipboard',
    imgpath: 'assets/img/icons/clipboard.svg',
    order: 4,
    subitems: [{
        name: 'Classic',
        link: '/forms/classic'
    }, {
        name: 'Validation',
        link: '/forms/validation'
    }, {
        name: 'Advanced',
        link: '/forms/advanced'
    }, {
        name: 'Material',
        link: '/forms/material'
    }, {
        name: 'Editors',
        link: '/forms/editor'
    }, {
        name: 'Upload',
        link: '/forms/upload'
    }]
};

const Tables = {
    name: 'Tables',
    link: 'tables',
    order: 5,
    // iconclass: 'ion-navicon',
    imgpath: 'assets/img/icons/navicon.svg',
    subitems: [{
        name: 'Classic',
        link: '/tables/classic'
    }, {
        name: 'Datatables',
        link: '/tables/datatables'
    }]
};

const Layouts = {
    name: 'Layouts',
    link: 'layouts',
    order: 5.1,
    // iconclass: 'ion-grid',
    imgpath: 'assets/img/icons/grid.svg',
    subitems: [{
        name: 'Columns',
        link: '/layouts/columns'
    }, {
        name: 'Overlap',
        link: '/layouts/overlap'
    }, {
        name: 'Boxed',
        link: '/layouts/boxed'
    }, {
        name: 'Tabs Deep Link',
        link: '/layouts/tabs'
    }, {
        name: 'Containers',
        link: '/layouts/containers'
    }]
};

const Elements = {
    name: 'Elements',
    link: '/elements',
    // iconclass: 'ion-levels',
    imgpath: 'assets/img/icons/levels.svg',
    order: 6,
    subitems: [{
        name: 'Colors',
        link: '/elements/colors'
    }, {
        name: 'Whiteframes',
        link: '/elements/whiteframes'
    }, {
        name: 'Lists',
        link: '/elements/lists'
    }, {
        name: 'Bootstrapui',
        link: '/elements/bootstrapui'
    }, {
        name: 'Buttons',
        link: '/elements/buttons'
    }, {
        name: 'Sweet-alert',
        link: '/elements/sweetalert'
    }, {
        name: 'Spinners',
        link: '/elements/spinners'
    }, {
        name: 'Navtree',
        link: '/elements/navtree'
    }, {
        name: 'Grid',
        link: '/elements/grid'
    }, {
        name: 'Typography',
        link: '/elements/typography'
    }, {
        name: 'Icons',
        link: '/elements/icons'
    }, {
        name: 'Utilities',
        link: '/elements/utilities'
    }]
};


const Pages = {
    name: 'Pages',
    link: 'pages',
    order: 8,
    // iconclass: 'ion-ios-browsers',
    imgpath: 'assets/img/icons/ios-browsers.svg',
    subitems: [{
        name: 'Timeline',
        link: '/pages/timeline'
    }, {
        name: 'Invoice',
        link: '/pages/invoice'
    }, {
        name: 'Pricing',
        link: '/pages/pricing'
    }, {
        name: 'Contacts',
        link: '/pages/contacts'
    }, {
        name: 'FAQ',
        link: '/pages/faq'
    }, {
        name: 'Projects',
        link: '/pages/projects'
    }, {
        name: 'Blog',
        link: '/pages/blog'
    }, {
        name: 'Article',
        link: '/pages/article'
    }, {
        name: 'Profile',
        link: '/pages/profile'
    }, {
        name: 'Gallery',
        link: '/pages/gallery'
    }, {
        name: 'Wall',
        link: '/pages/wall'
    }, {
        name: 'Search',
        link: '/pages/search'
    }, {
        name: 'Messages Board',
        link: '/pages/messages'
    }]
};

const User = {
    name: 'User',
    link: 'user',
    order: 9,
    // iconclass: 'ion-person-stalker',
    imgpath: 'assets/img/icons/person-stalker.svg',
    subitems: [{
        name: 'Login',
        link: '/login'
    }, {
        name: 'Signup',
        link: '/signup'
    }, {
        name: 'Lock',
        link: '/lock'
    }, {
        name: 'Recover',
        link: '/recover'
    }]
};

const Uploader = {
    name: 'Import',
    link: '/uploader',
    order: 10,
    iconclass: 'ion-filing',
    subitems: [{
        name: 'File uploader',
        link: '/uploader'
    },{
        name: 'Product Queue',
        link: '/uploader/queue'
    }]
    //imgpath: 'assets/img/icons/radio-waves.svg'
};

const Manufacturers = {
    name: 'Manufacturers',
    link: '/manufacturers',
    order: 11,
     iconclass: 'ion-settings',
    //imgpath: 'assets/img/icons/radio-waves.svg'
};

const Dealers = {
    name: 'Dealers',
    link: '/dealers',
    order: 12,
    iconclass: 'ion-person-stalker',
};

const DealersDashboard = {
  name: 'Dealers dashboard',
  link: '/dealers/dashboard',
  order: 13,
  iconclass: 'ion-stats-bars',
};

const Products = {
    name: 'Products',
    link: '/products',
    order: 14,
     iconclass: 'ion-pricetags',
    //imgpath: 'assets/img/icons/radio-waves.svg'
};

const LogisticsDashboard = {
  name: 'Logistics dashboard',
  link: '/dashboard/logistics',
  order: 15,
  iconclass: 'ion-shuffle',
};
const ProductsElastic = {
    name: 'Products ES',
    link: '/products/es',
    order: 16,
     iconclass: 'ion-pricetags',
    //imgpath: 'assets/img/icons/radio-waves.svg'
};

const Orders = {
    name: 'Orders',
    link: '/orders',
    order: 17,
     iconclass: 'ion-filing',
    //imgpath: 'assets/img/icons/radio-waves.svg'
};

const Configurations = {
  name: 'Configurations',
  link: '/configurations',
  order: 18,
  imgpath: 'assets/img/icons/navicon.svg',
  //imgpath: 'assets/img/icons/radio-waves.svg'
};

const Admin = {
  name: 'Admin',
  link: '/admin',
  order: 19,
  iconclass: 'ion-settings',
  subitems: [{
    name: 'User Management',
    link: '/admin/user-management',
  }]
  //imgpath: 'assets/img/icons/radio-waves.svg'
};

const DealersPortalDashboard = {
  name: 'Dashboard',
  link: '/dealers-portal',
  // iconclass: 'ion-aperture',
  imgpath: 'assets/img/icons/aperture.svg',
  order: 1,
  /*label: {
      count: 2,
      classname: 'badge bg-success'
  }*/
};

const DealersPortalProducts = {
  name: 'Products',
  link: '/dealers-portal/products',
  order: 2,
  iconclass: 'ion-pricetags',
  //imgpath: 'assets/img/icons/radio-waves.svg'
};

const DealersPortalOrders = {
  name: 'Orders',
  link: '/dealers-portal/orders',
  order: 4,
  iconclass: 'ion-filing',
};

var tempMenu = [
    Dashboard,
    Uploader,
    Dealers,
    DealersDashboard,
    Products,
    //ProductsElastic,
    Manufacturers,
    Orders,
    Cards,
    Forms,
    Tables,
    Layouts,
    Elements,
    Pages,
    User,
    Configurations,
    Admin,
    LogisticsDashboard
];

if(environment.production){
  tempMenu = [
      Dashboard,
      LogisticsDashboard,
      Dealers,
      DealersDashboard,
      Manufacturers,
      Products,
      Orders,
      Configurations,
      Admin
  ];
}

const tmp_business_menu = [
  Dashboard,
  Uploader,
  Dealers,
  DealersDashboard,
  Products,
  //ProductsElastic,
  Manufacturers,
  Orders,
  Cards,
  Forms,
  Tables,
  Layouts,
  Elements,
  Pages,
  LogisticsDashboard
]

const tmp_dealers_portal_menu = [
  DealersPortalDashboard,
  DealersPortalProducts,
  DealersPortalOrders
]

export const menu = tempMenu;
export const dealers_portal_menu = tmp_dealers_portal_menu;
export const business_menu = tmp_business_menu;



// WEBPACK FOOTER //
// /home/alinu/Alin/Work/Workspace/BART-client/src/app/routes/menu.ts